import { Component } from '@angular/core';
import { FeedbackType } from 'src/app/general-components/feedback/feedback-type';
import { FeedbackSettings } from 'src/app/general-components/feedback/feedback-settings';
import { SOSEmailService } from '../sos-email.service';
import { SOSCustomer } from '../sos-customer';

@Component({
  selector: 'app-sos-email-no-response',
  templateUrl: './sos-email-indi-no-response.component.html',
  styleUrls: ['./sos-email-indi-no-response.component.scss'],
})
export class SOSEmailForOrdersWithoutResponseComponent {
  isYesterdayChecked: boolean;

  didSearch: boolean = false;
  sosCustomers: SOSCustomer[] = [];

  isLoading: boolean = false;
  showFeedback: boolean = false;

  feedbackSettings: FeedbackSettings = {
    identifier: '',
    show: false,
    type: FeedbackType.error,
    message: 'Er is iets misgegaan sorry',
    closeButton: false,
  };

  constructor(private service: SOSEmailService) {
    this.isYesterdayChecked = new Date().getHours() < 13;
  }

  updateFeedback(type: FeedbackType, message: string) {
    this.feedbackSettings.identifier = '';
    this.feedbackSettings.show = true;
    this.feedbackSettings.closeButton = true;
    this.feedbackSettings.buttonText = undefined;

    this.feedbackSettings.type = type;
    this.feedbackSettings.message = message;
  }

  getSOSCustomers() {
    this.isLoading = true;
    this.didSearch = false;
    this.service.getSOSCustomersForOrdersWithoutResponse(this.isYesterdayChecked).subscribe({
      next: (sosCustomers: SOSCustomer[]) => {
        this.didSearch = true;
        this.sosCustomers = sosCustomers;
        this.isLoading = false;
      },
      error: (error: Error) => {
        this.updateFeedback(FeedbackType.error, 'Er is *iets* fout gegaan bij het ophalen van de order informatie');
        this.isLoading = false;
        console.error(error);
      },
    });
  }

  allowQueryAgain() {
    this.didSearch = false;
    this.sosCustomers = [];
  }
}
